import React, { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonFrom from "../../../Common/Components/Form";
import { EditData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Get } from "../../../../Request";
const EditItemDetails = ({ isApp }) => {
  const initialState = {
    loading: true,
    loadingBtn: false,
  };
  const navigate = useNavigate();
  const userType = JSON.parse(localStorage.getItem("user_type"));

  const [state, setstate] = useState(initialState);
  const [data, setData] = useState({});
  const { slug } = useParams();
  const middleware = data => {
    return {
      ...data,
      itemoptins:
        data.itemoptins &&
        data.itemoptins.map(({ id: value, name: label }) => ({ value, label })),
    };
  };
  const getSingle = async slug => {
    setstate({ loading: true });

    await Get({
      url: "/item/single",
      data: {
        slug,
      },
    }).then(data => {
      setData(data);
      setstate({ loading: false });
    });
  };
  useEffect(() => {
    getSingle(slug);
  }, []);

  const Handler = data => {
    data = {
      ...data,
      tags: data.tags.map(tag => tag.value),
      options: data.itemoptins.map(op => op.value),
    };
    setstate({ loadingBtn: true });
    EditData(data).then(() => {
      setstate({
        loadingBtn: false,
      });

      // navigate(-1);
    });
  };
  if (state.loading) {
    return <Loading count={1} col={12} height={300} />;
  }

  let input = [
    {
      label: "عنوان مجموعه",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "name",
    },
    {
      label: "جنسیت ورزشکاران",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "gender",
      input: "select",
      options: [
        {
          id: "men",
          name: "آقایون",
        },
        {
          id: "women",
          name: "بانوان",
        },
        {
          id: "both",
          name: "هر دو",
        },
      ],
    },
    {
      label: "امکانات مجموعه",
      size: "col-md-3",
      classNames: "mt-2 js-select2",
      placeholder: "",
      name: "itemoptins",
      input: "selectTable",
      multiple: true,
      nested: "itemoptins",
    },
    {
      label: "قیمت رزرو",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "header_price",
      sepMoney: true,
    },
    {
      label: "شماره همراه",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "details",
      keyname: "mobile",
    },
    {
      label: "شماره ثابت",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "details",
      keyname: "phone",
    },

    {
      label: "شماره ثبت",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "registration_number",
    },
    {
      label: "تگ های مجموعه",
      size: "col-md-3",
      classNames: "mt-2 js-select2",
      placeholder: "",
      name: "tags",
      input: "selectTable",
      multiple: true,
      nested: "tags",
    },

    {
      label: "انتخاب دسته بندی",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "category_id",
      input: "select",
      nested: "category",
    },
    {
      label: "موقعیت جغرافیایی",
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "location",
    },
    {
      label: "آدرس کامل",
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "address",
    },
    {
      label: "تصاویر مجموعه",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "images",
      input: "file",
      accept: "image/png, image/jpeg",
      alt: true,
    },
    {
      label: "تصویر شاخص مجموعه - فقط یک مورد عکس انتخاب کنید",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "header_image",
      input: "file",
      accept: "image/png, image/jpeg",
    },
    {
      label: "کلمات کلیدی سئو",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoKeyword",
      input: "textarea",
    },
    {
      label: "توضیحات کلیدی سئو",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoDescription",
      input: "textarea",
    },
    {
      label: "کد اسکیما",
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "seo",
      keyname: "seoSchema",
      // input: "textarea",
    },

    {
      label: <span>توضیحات <span className="text-danger">ضروری</span> مجموعه</span>,
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "necessary_description",
      input: "ckeditor",
    },
    {
      label: "توضیحات مجموعه",
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "description",
      input: "ckeditor",
    },
    {
      label: "قوانین و مقررات ",
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "rules",
      input: "ckeditor",
    },
    {
      name: "استان شهرستان منطقه",
      input: "region",
      col: "col-md-12",
      key: "region_id",
    },
  ];
  if (userType == "manager") {
    input = [{
      label: "قوانین و مقررات ",
      size: "col-md-12",
      classNames: "mt-3",
      placeholder: "",
      name: "rules",
      input: "ckeditor",
      brData: isApp
    }]
  }
  const renderSlug = () => {
    let slugList = slug && slug.split("-");
    let res = "";
    slugList &&
      slugList.map(ch => {
        if (!(typeof ch == "number")) {
          res += " " + ch;
        }
      });
    return res;
  };
  return (
    <Fragment>
      <div className={isApp && "editeBox pt-2 pb-3"}>
        <CommonFrom
          form={input}
          // form={managerInput }
          loading={state.loadingBtn}
          // header={`ویرایش مجموعه ${renderSlug()}`}
          textbtn="لیست مجموعه ها"
          linkbtn="/Admin/Item/List"
          btnName="ویرایش"
          initialeState={{ item_id: data.Items.id }}
          submit={Handler}
          value={middleware(data.Items)}
          nested={["tags", "category", "itemoptins"]}
          edit={true}
          isApp
        ></CommonFrom>
      </div>

    </Fragment>
  );
};

export default EditItemDetails;
